export function parseNumber(value: string): number {
  value = value?.toString().replace(/,/g, '') ?? '0';
  return parseFloat(value);
}
